var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo",style:({ alignItems: { start: "flex-start" }[_vm.align] })},[_c('img',{style:(_vm.style),attrs:{"src":_vm.src,"alt":"樂台計畫"}})])}
var staticRenderFns = []

export { render, staticRenderFns }